import { InfoCircleOutlined, InfoCircleTwoTone } from '@ant-design/icons';
import { Row, Tooltip } from 'antd';

import { Status } from 'components';

import { snapStore } from '../../store';

export const TitleExtraNode = () => {
  const status = snapStore((state) => state.status);
  const hasDirtyTransactions = snapStore((state) => state.snapBooleanStatuses.hasDirtyTransactions);
  const hasConflictedMatches = snapStore((state) => state.snapBooleanStatuses.hasConflictedMatches);

  return (
    <Row align='middle'>
      <Status status={status} />

      {hasDirtyTransactions && (
        <Tooltip title='Waiting for Participation data synchronisation'>
          <InfoCircleTwoTone className='text-[18px]' />
        </Tooltip>
      )}

      {hasConflictedMatches && (
        <Tooltip title='This snap has more than 1 match for a specific line item'>
          <InfoCircleOutlined className='text-[18px] text-[#faad14] ml-2' />
        </Tooltip>
      )}
    </Row>
  );
};
